import React, { useMemo } from 'react';
import { Table } from 'js/components/common/Table';
import { compose, pick } from 'js/utils/ramda.util';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { SCHEDULED_BREAKS } from './constants';
import { useDynamicReducerSelector, withDynamicReducer } from './store';
import { AddNewScheduledBreak } from './components/AddNewScheduledBreak';

import * as style from './ScheduledBreaks.scss';

export const ScheduledBreaksBare = () => {
    const translate = useComponentTranslations();
    const { isLoading, error, isFetchError } = useDynamicReducerSelector(pick([
       'isLoading', 'error', 'isFetchError'
    ]));
    const tableData = hooks.useTableData();
    const afterFiltersControls = useMemo(() => [{
        id: 0,
        content: <AddNewScheduledBreak />
    }], []);

    hooks.useFetchComponent();

    return (
        <Table
            error={error}
            classNames={style}
            isLoading={isLoading}
            tableData={tableData}
            title={translate('title')}
            emptyTitle={translate('empty')}
            description={translate('description')}
            showTableBody={Boolean(!isFetchError)}
            afterFiltersControls={afterFiltersControls}
        />
    );
};

export const ScheduledBreaks = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.scheduledBreaks.'
    }),
    withDynamicReducer()
)(ScheduledBreaksBare);

componentService.registerPageComponents({ [SCHEDULED_BREAKS]: ScheduledBreaks });
